import styled from 'styled-components'

export const InfoContainer = styled.div`
  display: flex;
  min-width: 480px;
  width: 640px;
  box-shadow: 0px 2px 10px -6px #252525;
  border-radius: 15px;
  flex-direction: column;
  justify-content: space-between;
  padding: 8px 15px;
  margin-bottom: 10px;
`

export const LabelRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr repeat(3, 2fr);
  justify-content: center;
  align-items: center;
  justify-items: center;
  margin-bottom: 7px;
  padding: 0px 15px;
  min-width: 720px;
  width: 960px;
`

export const EarningContainer = styled(InfoContainer)`
  display: grid;
  grid-template-columns: 2fr 1fr 2fr 2fr 2fr;
  justify-content: center;
  align-items: center;
  justify-items: center;
  min-width: 720px;
  width: 960px;
  height: auto;
`

export const Image = styled.img`
  width: 20px;
  height: 20px;
`
